import React, { useEffect, useState } from "react";
import API, { BASE_URL } from "../api/Api";

export default function RegistrationProcess() {
  const [steps, setSteps] = useState([]);

  // 🔹 Fetch registration steps
  useEffect(() => {
    API.get("/registration-steps")
      .then((res) => {
        setSteps(res.data.data || []);
      })
      .catch((err) => {
        console.error("Registration Steps API Error", err);
      });
  }, []);

  return (
    <section className="process-section">
      <div className="container text-center mb-5">
        <h2 className="process-title">Simple Registration Process</h2>
        <p className="process-subtitle">
          Get started in just 4 easy steps
        </p>
      </div>

      <div className="container">
        <div className="row g-4 align-items-stretch">

          {steps.map((step, index) => (
            <div className="col-lg-3 col-md-6" key={step.step_id}>
              <div className="step-card">

                {/* 🔹 ICON → IMAGE */}
                <div className="step-icon bg-purple">
                  <img
                    src={`${BASE_URL}/assets/images/${step.image}`}
                    alt={step.title}
                    className="step-img"
                  />
                </div>

                <div className="step-no">
                  {String(step.step_number).padStart(2, "0")}
                </div>

                <h4>{step.title}</h4>
                <p>{step.description}</p>

                {/* 🔹 PROGRESS (dynamic) */}
                <div className="step-progress">
                  {[1, 2, 3, 4].map((n) => (
                    <span
                      key={n}
                      className={n <= step.step_number ? "active" : ""}
                    ></span>
                  ))}
                </div>

                {/* 🔹 Arrow except last */}
                {index !== steps.length - 1 && (
                  <i className="fa-solid fa-arrow-right step-arrow"></i>
                )}
              </div>
            </div>
          ))}

        </div>
      </div>
    </section>
  );
}
